import classNames from "../../utils/classNames";
import Tooltip from "../shared/Tooltip";

interface BayCapacityDotsProps {
  easyFilled: number;
  easyCap: number;
  mediumFilled: number;
  mediumCap: number;
  hardFilled: number;
  hardCap: number;
}

const dotClasses = (filled: number, cap: number, base: string) => {
  if (cap === 0) return "bg-gray-200";
  if (filled >= cap) return "bg-gray-400";
  return base;
};

export default function BayCapacityDots({
  easyFilled,
  easyCap,
  mediumFilled,
  mediumCap,
  hardFilled,
  hardCap,
}: BayCapacityDotsProps) {
  return (
    <div className="flex items-center gap-x-2 text-[11px] text-gray-600">
      <Tooltip content={`Easy: ${easyFilled} / ${easyCap}`}>
        <span className="flex items-center gap-x-1 cursor-help">
          <span className={classNames("h-2 w-2 rounded-full", dotClasses(easyFilled, easyCap, "bg-green-500"))} />
          {easyFilled}/{easyCap}
        </span>
      </Tooltip>
      <Tooltip content={`Medium: ${mediumFilled} / ${mediumCap}`}>
        <span className="flex items-center gap-x-1 cursor-help">
          <span className={classNames("h-2 w-2 rounded-full", dotClasses(mediumFilled, mediumCap, "bg-amber-500"))} />
          {mediumFilled}/{mediumCap}
        </span>
      </Tooltip>
      <Tooltip content={`Hard: ${hardFilled} / ${hardCap}`}>
        <span className="flex items-center gap-x-1 cursor-help">
          <span className={classNames("h-2 w-2 rounded-full", dotClasses(hardFilled, hardCap, "bg-red-500"))} />
          {hardFilled}/{hardCap}
        </span>
      </Tooltip>
    </div>
  );
}
